import { Book } from './Book';
import { Chapter } from './Chapter';
import { Edition } from './Edition';
import { Item } from './Item';
import { Page } from './Page';

export interface BookOutline extends Item {
  bookId: number;
  book?: Book;
  editionId: number;
  edition?: Edition;
  chapters: Chapter[];
  pages: Page[];
  contentLength?: number;
  docs?: string[];
  bookUploadId?: number;
}

export type OutlinePrimitive = Pick<BookOutline, 'chapters' | 'pages'>;

export const outlineHasPages = (outline: BookOutline | null): boolean => {
  if (!outline?.pages) {
    return false;
  }

  return outline?.pages?.length > 0;
};

export const outlineHasChapters = (outline: BookOutline | null): boolean => {
  if (!outline?.chapters) {
    return false;
  }
  return outline?.chapters?.length > 0;
};

type FlattenedChapterWithLevel = Chapter & { level: number };
export const flattenChapters = (chapters: Chapter[], depth = 0): FlattenedChapterWithLevel[] => {
  const flattened: FlattenedChapterWithLevel[] = [];
  chapters.forEach((chapter) => {
    flattened.push({ ...chapter, label: `${'   '.repeat(depth)}${chapter.label}`, level: depth });
    if (chapter.chapters) {
      const children = flattenChapters(chapter.chapters, depth + 1);
      flattened.push(...children);
    }
  });

  return flattened;
};
